import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.sidebar = document.getElementById("AiSidebar")
    this.updateVisibility()
  }

  updateVisibility() {
    const sidebarIsVisible = this.sidebar?.classList.contains("d-flex") || this.sidebar?.classList.contains("d-lg-flex")

    if (sidebarIsVisible) {
      this.buttonTarget.classList.add("d-none")
    } else {
      this.buttonTarget.classList.remove("d-none")
      this.buttonTarget.classList.remove("d-inline-block")
    }
  }

  toggleSidebar() {
    if (!this.sidebar) return

    if (this.sidebar.classList.contains("d-lg-flex")) {
      this.sidebar.classList.remove("d-lg-flex")
    }

    this.sidebar.classList.toggle("d-flex")
    this.updateVisibility()
  }
}
